<template>
        <form
      autocomplete="off"
      data-vv-scope="stepContent1"
      @submit.prevent="next('stepContent1', 'dadosEndereco')"
    >
      <div class="row">
        <div class="col">
          <b-alert class="mb-2" ref="alertIdade" :show="exibeAlertaIdade" variant="warning" dismissible>
            <p><b>Alerta!</b></p>
            <p class="form-text">Informe ao cliente que sua idade não permite contratar os seguros Internação e/ou Funeral.</p>
          </b-alert>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <h4>Dados Titular</h4>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="form-group col">
          <div class="form-group" :class="{'has-danger': errors.has('stepContent1.plano')}">
            <label for="plano">Selecione o Plano</label>
            <select
              name="plano"
              class="form-control"
              id="plano"
              @change="$validator.reset()"
              v-validate="'required'"
              v-model="payload.plano"
            >
              <option :value="null">Selecione</option>
              <option
                v-for="plano in planos"
                :key="plano._id"
                :value="plano"
              >{{plano.name}} ({{plano.price | money}}/mês) {{plano.valorTaxaAdesao ? ' + Taxa Adesão: ' + $options.filters.money(plano.valorTaxaAdesao) : ''}}</option>
            </select>
            <small v-if="listBeneficio.length > 0" @click="$bvModal.show('modalInfoPlano')" style="cursor: pointer" class="text-muted">Detalhes do plano <i class="fa fa-info-circle"></i></small>
            <div
              v-if="errors.has('stepContent1.plano')"
              class="help-block form-text text-muted form-control-feedback"
            >{{errors.first('stepContent1.plano')}}</div>
          </div>
        </div>
      </div>
      <hr />
      <div class="form-row">
        <div class="form-group col-md-6" :class="{'has-danger': errors.has('stepContent1.name')}">
          <label for="username">Nome Completo</label>
          <input
            type="text"
            name="name"
            id="name"
            v-validate="'required'"
            v-model="payload.name"
            class="form-control"
          />
          <div
            v-if="errors.has('stepContent1.name')"
            class="help-block form-text text-muted form-control-feedback"
          >{{errors.first('stepContent1.name')}}</div>
        </div>
        <div class="form-group col-md-3" :class="{'has-danger': errors.has('stepContent1.cpf')}">
          <label for="username">CPF</label>
          <input
            type="tel"
            name="cpf"
            id="cpf"
            v-mask="'###.###.###-##'"
            v-validate="'required|cpf'"
            v-model="payload.cpf"
            class="form-control"
          />
          <div
            v-if="errors.has('stepContent1.cpf')"
            class="help-block form-text text-muted form-control-feedback"
          >{{errors.first('stepContent1.cpf')}}</div>
        </div>
        <div class="form-group col-md-3">
          <div
            class="form-group"
            :class="{'has-danger': errors.has('stepContent1.dataNascimento')}"
          >
            <label for="date">Data de Nascimento</label>
            <input
              type="tel"
              name="dataNascimento"
              id="dataNascimento"
              @keyup="validaDataNascimento"
              v-validate="'required|date_format:dd/MM/yyyy'"
              v-model="payload.dataNascimento"
              v-mask="'##/##/####'"
              class="form-control"
              aria-describedby="helpId"
            />
            <small v-if="age" class="text-muted form-text">Idade: {{age}}</small>
            <div
              v-if="errors.has('stepContent1.dataNascimento')"
              class="help-block form-text text-muted form-control-feedback"
            >{{errors.first('stepContent1.dataNascimento')}}</div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-3">
          <div class="form-group" :class="{'has-danger': errors.has('stepContent1.sexo')}">
            <label for="sexo">Sexo</label>
            <select
              name="sexo"
              class="form-control"
              id="sexo"
              v-validate="'required'"
              v-model="payload.sexo"
            >
              <option :value="null">Selecione</option>
              <option value="M">Masculino</option>
              <option value="F">Feminino</option>
            </select>
            <div
              v-if="errors.has('stepContent1.sexo')"
              class="help-block form-text text-muted form-control-feedback"
            >{{errors.first('stepContent1.sexo')}}</div>
          </div>
        </div>
        <div class="form-group col-md-6">
          <div class="form-group" :class="{'has-danger': errors.has('stepContent1.naturalidade')}">
            <label for="naturalidade">Naturalidade</label>
            <input
              type="text"
              name="naturalidade"
              id="naturalidade"
              v-validate="'required'"
              v-model="payload.naturalidade"
              class="form-control"
              aria-describedby="helpId"
            />
            <div
              v-if="errors.has('stepContent1.naturalidade')"
              class="help-block form-text text-muted form-control-feedback"
            >{{errors.first('stepContent1.naturalidade')}}</div>
          </div>
        </div>
        <div class="form-group col-md-2">
          <div class="form-group" :class="{'has-danger': errors.has('stepContent1.estado')}">
            <label for="estado">Estado</label>
            <select
              name="estado"
              class="form-control"
              id="estado"
              v-model="payload.uf"
              v-validate="'required'"
            >
              <option :value="null">Selecione</option>
              <option v-for="uf in ufs" :key="uf" :value="uf" v-text="uf" />
            </select>
            <div
              v-if="errors.has('stepContent1.estado')"
              class="help-block form-text text-muted form-control-feedback"
            >{{errors.first('stepContent1.estado')}}</div>
          </div>
        </div>
      </div>
      <hr />

      <div class="form-row">
        <div class="form-group col-md-6">
          <div class="form-group" :class="{'has-danger': errors.has('stepContent1.email')}">
            <label for="email">E-mail</label>
            <input
              type="email"
              name="email"
              id="email"
              v-model="payload.email"
              v-validate="'required|email'"
              class="form-control"
              aria-describedby="helpId"
            />
            <div
              v-if="errors.has('stepContent1.email')"
              class="help-block form-text text-muted form-control-feedback"
            >{{errors.first('stepContent1.email')}}</div>
          </div>
        </div>
        
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <div class="form-group" :class="{'has-danger': errors.has('stepContent1.celular')}">
            <label for="celular">Celular</label>
            <input
              type="tel"
              name="celular"
              id="celular"
              v-model="payload.telefoneCelular"
              v-validate="'required'"
              v-mask="['(##) ####-####', '(##) #####-####']"
              class="form-control"
              aria-describedby="helpId"
            />
            <div
              v-if="errors.has('stepContent1.celular')"
              class="help-block form-text text-muted form-control-feedback"
            >{{errors.first('stepContent1.celular')}}</div>
          </div>
        </div>
        <div class="form-group col-md-6">
          <div class="form-group" :class="{'has-danger': errors.has('stepContent1.telefoneFixo')}">
            <label for="celular">Tel. Residencial</label>
            <input
              type="tel"
              name="telefoneFixo"
              id="telefoneFixo"
              v-model="payload.telefoneFixo"
              v-mask="['(##) ####-####']"
              class="form-control"
              aria-describedby="helpId"
            />
            <div
              v-if="errors.has('stepContent1.telefoneFixo')"
              class="help-block form-text text-muted form-control-feedback"
            >{{errors.first('stepContent1.telefoneFixo')}}</div>
          </div>
        </div>
      </div>
      <div class="form-buttons-w text-right">
        <button class="btn btn-primary step-trigger-btn" type="submit">Continuar</button>
      </div>
      <b-modal id="modalInfoPlano" title="Informações do plano" size-xl hide-footer>
      <div class="container" v-if="payload.plano">
        <div id="printable">
          <div class="row">
            <div class="col-8">
              <label>Plano contratado</label>
              <h5>{{payload.plano.name}}</h5>
            </div>
            <div class="col">
              <label>Preço</label>
              <h5>{{payload.plano.price | money}}/mês</h5>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col">
              <label>Benefícios</label>
            </div>
          </div>
          <div class="row" v-for="beneficio in listBeneficio" :key="beneficio._id">
            <div class="col">
              <label>{{beneficio.titulo}}</label> <small style="color: red" v-if="!beneficio.permiteAcimaDe70Anos"> (*) IDADE LIMITE INFERIOR A 70 ANOS</small>
              <br />
              <ul>
                <li v-for="texto in beneficio.textoBeneficios" :key="texto">{{texto}}</li>
              </ul>
            </div>
          </div>
          <hr />
        </div>
      </div>
    </b-modal>

    </form>
</template>
<script>
import { Validator } from "vee-validate";
import utils from "@/utils";

import http from 'axios';
import ufs from '@/utils/ufs';


export default {
    props: {
        payload: {
            type: Object,
            required: true
        }
    },
    computed: {
        step() {
            return this.$store.getters.step;
        },
        empresa() {
            return this.$store.getters.empresa;
        },
        ufs() {
          return ufs;
        },
        isValidaDataNascimento() {
          return this.payload.plano && this.listBeneficio.find(ben => !ben.permiteAcimaDe70Anos);
        }
    },
    data() {
        return {
            planos: [],
            listBeneficio: [],
            exibeAlertaIdade: false,
            age: 0
        }
    },
    watch: {
      'payload.plano': async function(value) {
        if (value) {
          let strBeneficio = `${value.beneficiosPlano}`;
          strBeneficio = strBeneficio.replace(/[" []]/gi, "");
          const responseBeneficiosPlano = await http.get(
            `/api/beneficio?_id__in=${strBeneficio}`
          );
          this.listBeneficio = responseBeneficiosPlano.data;
        } else {
          this.listBeneficio = [];
        }
      }
    },
    created() {
      Validator.extend("cpf", {
        getMessage: () => "CPF inválido",
        validate: value => {
          return !!utils.TestaCPF(value);
        }
      });
      Validator.extend("dataNascimentoPlano", {
        getMessage: () =>
          "A idade para contratação desse plano deve ser entre 16 e 69 anos",
        validate: value => {
          if (this.isValidaDataNascimento) {
            let age = this.calcAge(value);
            return !!(age >= 16 && age < 70);
          }
          return true;
        }
      });
    },
    async mounted () {
        const response = await http.get(`api/juridica/${this.empresa._id}/plans`);
        this.planos = response.data;
    },
    methods: {
        calcAge(dateString) {
          const [dia, mes, ano] = dateString.split("/");
          var birthday = +new Date(ano, parseInt(mes) - 1, dia, 0, 0, 0, 0);
          return ~~((Date.now() - birthday) / 31557600000);
        },
        validaDataNascimento() {
          if (this.isValidaDataNascimento && this.payload.dataNascimento && this.payload.dataNascimento.length === 10) {
            let age = this.calcAge(this.payload.dataNascimento);
            this.age = age;

            if (age >= 70) {
              this.exibeAlertaIdade = true;
              window.scrollTo(0,0);
            } else {
              this.exibeAlertaIdade = false;
            }
          } else {
            this.exibeAlertaIdade = false;
          }
        },
        next(from, to) {
            this.$validator.validateAll(from).then(result => {
                if (result) {
                    this.$store.dispatch('setStep', to);
                }
            });
        }
    }
}
</script>